import { Injectable } from "@angular/core";
import { LocalStorageConstants } from "src/app/shared/constants/localStorage.constants";

export interface MapViewSettings {
    showNodes: boolean;
    showWindCones: boolean;
    showHeatmap: boolean;
    riskType: string;
    showAirNowSensors: boolean;
}

@Injectable({
    providedIn: "root",
})
export class MapViewSettingsService {
    private defaultSettings: MapViewSettings = {
        showNodes: true,
        showWindCones: true,
        showHeatmap: false,
        riskType: "Dust Map",
        showAirNowSensors: false,
    };

    constructor() {}

    getSettings(): MapViewSettings {
        try {
            const stored = localStorage.getItem(
                LocalStorageConstants.dashboardMapViewSettings,
            );
            if (stored) {
                return { ...this.defaultSettings, ...JSON.parse(stored) };
            }
        } catch (error) {
            console.warn("Failed to retrieve map view settings from localStorage", error);
        }
        return { ...this.defaultSettings };
    }


    saveSettings(settings: Partial<MapViewSettings>): void {
        try {
            const current = this.getSettings();
            const updated = { ...current, ...settings };
            localStorage.setItem(
                LocalStorageConstants.dashboardMapViewSettings,
                JSON.stringify(updated),
            );
        } catch (error) {
            console.warn("Failed to save map view settings to localStorage", error);
        }
    }

    updateSetting<K extends keyof MapViewSettings>(
        key: K,
        value: MapViewSettings[K],
    ): void {
        this.saveSettings({ [key]: value } as Partial<MapViewSettings>);
    }

    clearSettings(): void {
        try {
            localStorage.removeItem(LocalStorageConstants.dashboardMapViewSettings);
        } catch (error) {
            console.warn("Failed to clear map view settings from localStorage", error);
        }
    }
}
